import { type FunctionReference, anyApi } from "convex/server";
import { type GenericId as Id } from "convex/values";

export const api: PublicApiType = anyApi as unknown as PublicApiType;
export const internal: InternalApiType = anyApi as unknown as InternalApiType;

export type PublicApiType = {
  auth: {
    validatePassword: FunctionReference<
      "mutation",
      "public",
      { password: string },
      any
    >;
    createAuthSession: FunctionReference<
      "mutation",
      "public",
      { sessionId: string },
      any
    >;
    validateSession: FunctionReference<
      "query",
      "public",
      { sessionId: string },
      any
    >;
    cleanupExpiredSessions: FunctionReference<
      "mutation",
      "public",
      Record<string, never>,
      any
    >;
    getUserAccount: FunctionReference<
      "query",
      "public",
      Record<string, never>,
      any
    >;
  };
  vapiActions: {
    makeVapiCall: FunctionReference<
      "action",
      "public",
      {
        agentType: string;
        bodyData: { email?: string; firstName?: string; lastName?: string };
        phoneNumber?: string;
        sessionId: string;
      },
      any
    >;
  };
  conversations: {
    list: FunctionReference<"query", "public", Record<string, never>, any>;
    get: FunctionReference<"query", "public", { id: Id<"conversations"> }, any>;
    create: FunctionReference<
      "mutation",
      "public",
      {
        lastMessage: string;
        messages: Array<{
          content: string;
          role: string;
          score?: string;
          timestamp: number;
          trace_id?: string;
        }>;
        sessionId: string;
        title: string;
      },
      any
    >;
    update: FunctionReference<
      "mutation",
      "public",
      {
        id: Id<"conversations">;
        lastMessage: string;
        messages: Array<{
          content: string;
          role: string;
          score?: string;
          timestamp: number;
          trace_id?: string;
        }>;
      },
      any
    >;
    deleteConversation: FunctionReference<
      "mutation",
      "public",
      { id: Id<"conversations"> },
      any
    >;
  };
  temporal: {
    signalConversationWorkflow: FunctionReference<
      "action",
      "public",
      {
        conversationId: Id<"conversations">;
        runId?: string;
        signalName?: string;
        workflowId?: string;
      },
      any
    >;
  };
  executiveSummary: {
    get: FunctionReference<"query", "public", Record<string, never>, any>;
    create: FunctionReference<
      "mutation",
      "public",
      { isGenerating: boolean; markdown: string },
      any
    >;
    update: FunctionReference<
      "mutation",
      "public",
      {
        id: Id<"executiveSummaries">;
        isGenerating?: boolean;
        markdown?: string;
      },
      any
    >;
  };
};
export type InternalApiType = {};
